module.exports = __webpack_public_path__ + "img/celestial-gate.0caa69cd.jpg";